import { decryptData } from "./cryptojs"

export const getPermission = () => {
    // var x = sessionStorage.authUser;
    let auth = localStorage.getItem("authUser") ? localStorage.getItem("authUser") : "";

    // if (localStorage.getItem("authUser")) {

    // }

    var permission = decryptData(auth);
    // console.log(permission);
    return permission?.ATUH_DATA
}
export const getUserToken = () => {
    let res = localStorage.getItem("authUser") ? localStorage.getItem("authUser") : "";
    res = decryptData(res);
    return res?.TOKEN
}
    // authUser